import { serviceContext$ } from '@pages/AdditionalServices/containers/bus';
import { OrderState } from '@pages/Basket/interfaces';
import { Order } from '@services/requests/orderService/interface';

import restoreServiceData from '../../basket/restoreServiceData';
import { clone } from '../../clone';
import { restoreAdditionalServiceState } from '../restoreAdditionalServiceState';

/**
 * editProductApproach проверяет тип редактируемого продукта, если тип отличим
 * от "complex" завершает выполнение, иначе восстанавливает данные продукта
 * и запускает восстановление стейта доп. услуг.
 *
 * @param data
 * @param langID
 * @param currencyID
 */
export const editProductApproach = async (data: OrderState, langID: string, currencyID: string) => {
  const state = clone(serviceContext$.getValue());
  const { editProduct } = data;

  const restoreResult = restoreServiceData(editProduct);

  if (editProduct.product_type !== 'complex' || !restoreResult.setUpService) {
    serviceContext$.next({
      ...state,
      IsRestoringState: false,
    });
    return;
  }

  restoreAdditionalServiceState(
    restoreResult.setUpService,
    restoreResult.otherServices,
    langID,
    currencyID
  );
};
